document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-section-type]').forEach(function (section) {
    section.addEventListener('variant:changed', updateDeliveryNote);
    section.addEventListener('change', function (e) {
      if (e.target.name === 'id') updateDeliveryNote({ target: section, detail: { variant: { id: e.target.value } } });
    });
  });

  function updateDeliveryNote(e) {
    const sectionEl = e.target.closest('[id^="shopify-section"]');
    if (!sectionEl) return;
    const sectionId = sectionEl.id.replace('shopify-section-', '');
    const noteEl = document.getElementById('variant-delivery-note-' + sectionId);
    if (!noteEl) return;

    const variantId = e.detail?.variant?.id || document.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    const url = window.location.pathname + '?variant=' + variantId + '&section_id=' + sectionId;
    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newNote = doc.getElementById('variant-delivery-note-' + sectionId);
        if (newNote) noteEl.innerHTML = newNote.innerHTML;
        noteEl.style.display = newNote?.innerHTML.trim() ? '' : 'none';
      });
  }
});
